import Flexbox from "../components/Flexbox";
import Spacebox from "../components/Spacebox";
import { useEffect, useState } from "react";
import { Container, Skeleton } from "@mui/material";
import Mode from "../components/styles/Mode";
import { updatedarkmode } from "../features/mode";
import cookies from "../utilities/Cookies";
import { useDispatch } from "react-redux";
import '../css/adrty.css'

const FCDR_TY = () => {

    const dispatch = useDispatch()

    const [firstname, setFirstName] = useState(null)
    const [lastname, setLastName] = useState(null)
    const [debtAmount, setDebtAmount] = useState(null)
    const [phone, setPhone] = useState(null)

    const [loading, setLoading] = useState(true)

    const items = [
        'Review your qualifying debts.',
        'Help you understand each option and the pros and cons.',
        'Help you find the option that saves you the most.'
    ]

    function formatUSPhoneNumber(input) {
        if (!input) return "";

        // remove everything except digits
        let digits = input.replace(/\D/g, "");

        // strip leading country code (1 or +1)
        if (digits.length === 11 && digits.startsWith("1")) {
            digits = digits.substring(1);
        }

        // must be exactly 10 digits now
        if (digits.length !== 10) return input; // fallback: return original

        const area = digits.substring(0, 3);
        const prefix = digits.substring(3, 6);
        const line = digits.substring(6);

        return `(${area}) ${prefix}-${line}`;
    }

    useEffect(() => {
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))

        const urlParams = new URLSearchParams(window.location.search)
        setFirstName(urlParams.get('first_name'))
        setLastName(urlParams.get('last_name'))
        setDebtAmount(urlParams.get('debt_amount'))
        setPhone(urlParams.get('phone'))
        setLoading(false)
        // eslint-disable-next-line
    }, [])

    return (
        <Mode>
            <div className="margin-auto bg adr-ty-page" style={{ padding: '20px' }}>
                {loading && (
                    <Container>
                        <div className="margin-auto" style={{ maxWidth: '400px', padding: '10px' }}>
                            <Skeleton variant="rounded" width={"100%"} height={200} />
                            <Spacebox padding="10px" />
                            <Skeleton variant="rounded" width={100} height={15} />
                            <Spacebox padding="10px" />
                            <Skeleton variant="rounded" width="100%" height={10} />
                            <Spacebox padding="5px" />
                            <Skeleton variant="rounded" width="100%" height={10} />
                            <Spacebox padding="5px" />
                            <Skeleton variant="rounded" width="100%" height={10} />
                            <Spacebox padding="5px" />
                            <Skeleton variant="rounded" width="100%" height={10} />
                            <Spacebox padding="5px" />
                            <Skeleton variant="rounded" width="100%" height={10} />
                        </div>
                    </Container>
                )}
                {!loading && <div>
                    {/* <span className="big-text">
                OPTIONS
            </span> */}
                    <span style={{ fontWeight: '700' }} className="text-primary bold heading">Reviewing Your <u>Debt Relief</u> Options</span>
                    <Spacebox padding="10px" />
                    <img src="/assets/header-image.png" alt="couples-holding-phone" style={{ width: '100%', borderRadius: 20 }} />
                    <Spacebox padding="10px" />
                    <div className="bg-shade" style={{ borderRadius: '10px' }}>
                        <Flexbox justifyContent="space-between" alignItems="center">
                            <div>
                                <small><b className="bold">Debt Help Options:</b></small>
                                <Spacebox padding="0px" />
                                <small><b>{firstname} {lastname}</b></small>
                            </div>
                            <div className="change-color">
                                <Spacebox padding="2px" />
                                <small><b className="bold">Estimated Debt:</b></small>
                                <Spacebox padding="0px" />
                                <small><b>${(parseFloat(debtAmount)).toLocaleString()}</b></small>
                                <Spacebox padding="2px" />
                            </div>
                            <div>
                                <small><b className="bold">Phone:</b></small>
                                <Spacebox padding="0px" />
                                <small><b>{formatUSPhoneNumber(phone)}</b></small>
                            </div>
                        </Flexbox>
                    </div>
                    <Spacebox padding="10px" />
                    <img src="/assets/mid-banner.png" alt="final-debt-relief" style={{ width: '100%' }} />
                    <Spacebox padding="10px" />
                    <Flexbox alignItems="flex-start">
                        <img src="/assets/verified.png" alt="verified" style={{ width: 20 }} />
                        <Spacebox padding="5px" />
                        <div>
                            <span><b className="bold">{firstname}, we're ready to help you. Based on the information you provided, multiple debt help options are available.</b></span>
                            <br /><br />
                            <span>
                                A certified counselor will reach out to you shortly (to the number you provided) to walk you through each of your qualifying debts and options.
                            </span>
                        </div>
                    </Flexbox>
                    <Spacebox padding="15px" />
                    <Flexbox alignItems="flex-start">
                        <img src="/assets/minute.png" alt="minute" style={{ width: 23 }} />
                        <Spacebox padding="5px" />
                        <div>
                            <span><b className="text-primary bold" style={{fontSize: '18px'}}>It only takes a few minutes for a debt specialist to:</b></span>
                            <Spacebox padding="10px" />
                            {items.map((item, i) => (
                                <div key={i}>
                                    <Flexbox alignItems="flex-start">
                                        <img src="/assets/check.png" alt="check" style={{ width: 20 }} />
                                        <Spacebox padding="5px" />
                                        <div>
                                            <span><b className={i === 0 ? 'bold' : ''}>{item}</b></span>
                                        </div>
                                    </Flexbox>
                                    <Spacebox padding="5px" />
                                </div>
                            ))}
                        </div>
                    </Flexbox>
                    <Spacebox padding="10px" />
                    <div style={{ padding: '10px 30px', backgroundColor: '#ffa62b10' }}>
                        <small style={{fontSize: '16px'}} className="text-primary">
                            Your personalized options will put you in control so you have the confidence you need, knowing what best meets your current needs.
                        </small>
                    </div>
                    <Spacebox padding="10px" />
                    <Flexbox alignItems="center" justifyContent="center">
                        <img src="/assets/headphone.png" alt="support" style={{ width: 40 }} />
                    </Flexbox>
                    <Spacebox padding="10px" />
                    <span style={{ display: 'block', textAlign: 'center' }}>
                        <b className="bold">If you need immediate assistance</b> to review your qualifying debts and options <br /><b><a href="tel:8664924512" className="text-primary bold" style={{ fontSize: 23, }}>(866) 492-4512</a></b>
                    </span>
                    <Spacebox padding="10px" />
                    <img src="/assets/logos_fcdr.png" alt="trusted brands" style={{ width: 350, display: 'block', margin: 'auto' }} />
                    <Spacebox padding="20px" />
                </div>}
            </div>
        </Mode>
    );
}

export default FCDR_TY;